import { LightOutlineButton } from 'components/Buttons';
import _, { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useGetPublication } from 'pages/publications_v2/hooks/useGetPublication';
import { useGetPublicationVersions } from 'pages/publications_v2/hooks/useGetPublicationVersions';
import { useGetVersionUrls } from 'pages/publications_v2/hooks/useGetVersionUrls';

/**
 * @param {import('models/approval.models').ApprovalItem} approvalItem
 */
export function PublicationItem({ approvalItem }) {
    const { t } = useTranslation();
    const publicationId = parseInt(approvalItem.target.externalId);
    const publication = useGetPublication(publicationId);
    const { publicationVersions } = useGetPublicationVersions(publicationId);

    const { htmlUrl, pdfUrl } = useGetVersionUrls(approvalItem.version.entityUri);

    const versionToCheck = publicationVersions.find((version) => version['@id'] === approvalItem.version.entityUri);

    const publishedFiles = [];

    if (!isEmpty(htmlUrl)) {
        publishedFiles.push({
            mediaType: 'html',
            url: htmlUrl,
        });
    }

    if (!isEmpty(pdfUrl)) {
        publishedFiles.push({
            mediaType: 'pdf',
            url: pdfUrl,
        });
    }

    return (
        <>
            <div className="mb-4">
                <div className="font-weight-bold text-uppercase">{publication?.name || t('ai:publicationItem.unknownName')}</div>
                <div className="small" style={{ color: '#64748b' }}>
                    {t('ai:publicationItem.info')}
                </div>
            </div>

            {publication && versionToCheck && (
                <div className="d-flex flex-column" style={{ gap: '1rem', maxWidth: 600 }}>
                    {publishedFiles.map(({ mediaType, url }, index) => (
                        <a
                            href={url}
                            target="_blank"
                            rel="noreferrer"
                            className="file-card flex-center justify-content-between p-3"
                            key={`file-${index}`}
                        >
                            <div className="flex-center">
                                <div className={`icon-box icon-box-${mediaType} mr-3`}>{getMediaType(mediaType)}</div>
                                <div>
                                    <div className="font-weight-bolder text-black" style={{ fontSize: 13 }}>
                                        {renderFilename(mediaType)}
                                    </div>

                                    {mediaType === 'print' && (
                                        <div className="small" style={{ color: '#64748b' }}>
                                            {t('ai:publicationItem.printLabel')}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div>
                                <LightOutlineButton size="sm" data-uk-tooltip={t('ai:publicationItem.tooltip')}>{t('ai:publicationItem.viewFileButton')}</LightOutlineButton>
                            </div>
                        </a>
                    ))}
                </div>
            )}
        </>
    );

    function getMediaType(mediaType) {
        if (mediaType === 'print') {
            return 'pdf';
        }

        return mediaType;
    }

    function getUrl(property) {
        if (property === 'print') {
            return '#';
        }

        if (property === 'pdf') {
            return versionToCheck.pdfUrl;
        }

        if (property === 'html') {
            return versionToCheck.htmlUrl;
        }

        return '#';
    }

    function renderFilename(property) {
        if (property === 'print') {
            return _.isEmpty(publication.printPdfFileName) ? '-' : publication.printPdfFileName + '.pdf';
        }

        if (property === 'pdf') {
            return _.isEmpty(publication.pdfFileName) ? '-' : publication.pdfFileName + '.pdf';
        }

        if (property === 'html') {
            return _.isEmpty(publication.htmlSlug) ? '-' : publication.htmlSlug + '.html';
        }

        return '-';
    }
}
